import { createGlobalStyle } from 'styled-components';
import { hqoTheme } from '@hqo/react-components-library/dist/hqo-theme-provider';

export const AppContentWrapperStyles = createGlobalStyle<{ customThemeFonts?: string[] | null }>`
  body {
    font-family: ${({ customThemeFonts }) => customThemeFonts?.join() || hqoTheme.fonts.join()};
  }
`;
